import PropTypes from "prop-types"
import React, { Component } from "react"
import Icon from "./Icon"
import { getAccountSettings } from "../../scripts/accountSettings"
import { injectIntl } from "react-intl"
import settingsMessages from "../../messages/settings"

class Hexagon extends Component {
  render() {
    const accountSettings = getAccountSettings(
      this.props.intl.formatMessage(settingsMessages.authenticAccountId)
    )
    const { colours } = accountSettings.settings
    const { icon, background, color, style } = this.props
    const newStyle = style ? { ...style } : {}
    const styles = {
      background: background,
      ...newStyle
    }

    return (
      <div className="hexagon" style={styles}>
        <Icon
          icon={"hexagon"}
          title={"hexagon"}
          style={{ color: colours.light, fontSize: "70px" }}
        />
        <Icon
          icon={"hexagon"}
          title={"hexagon"}
          style={{ color: colours.secondary, fontSize: "60px" }}
        />
        <Icon icon={icon} title={icon} style={{ color: color }} />
      </div>
    )
  }
}

Hexagon.propTypes = {
  icon: PropTypes.string.isRequired,
  background: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.object
}

export default injectIntl(Hexagon)



// WEBPACK FOOTER //
// ./webapp/components/elements/Hexagon.js